module.exports = __webpack_public_path__ + "assets/2f4c2e0c5043128cf22cb352acc1dc6e.mp3";